import React, { useEffect } from "react";
import Loading from "../../../../Panel/Common/Components/Loading";

const BlogContent = ({ loading, data }) => {
  useEffect(() => {
    const oembed = document.getElementsByTagName("oembed");

    if (oembed) {
      Array.from(oembed).forEach(element => {
        const url = element.getAttribute("url");
        const div = document.createElement("div");
        const span = document.createElement("span");
        const iframe = document.createElement("iframe");
        const att = document.createAttribute("class");
        const spanClass = document.createAttribute("class");
        const iframeClass = document.createAttribute("class");
        const divClass = document.createAttribute("class");
        const src = document.createAttribute("src");
        src.value = `https://www.aparat.com/video/video/embed/videohash/${
          url.split("/v/")[1]
        }/vt/frame`;
        att.value = "h_iframe-aparat_embed_frame";
        spanClass.value = "span_lashi";
        iframeClass.value = "iframe-content";
        divClass.value = "iframe-container";

        div.setAttributeNode(att);
        span.setAttributeNode(spanClass);
        iframe.setAttributeNode(iframeClass);
        div.setAttributeNode(divClass);

        const allowFullScreen = document.createAttribute("allowFullScreen");
        allowFullScreen.value = true;
        const webkitallowfullscreen = document.createAttribute(
          "webkitallowfullscreen"
        );
        webkitallowfullscreen.value = true;
        const mozallowfullscreen =
          document.createAttribute("mozallowfullscreen");
        mozallowfullscreen.value = true;

        iframe.setAttributeNode(src);
        iframe.setAttributeNode(allowFullScreen);
        iframe.setAttributeNode(webkitallowfullscreen);
        iframe.setAttributeNode(mozallowfullscreen);
        div.appendChild(span);
        div.appendChild(iframe);
        window.$(element).after(div);
        element.remove();
      });
    }
  }, [loading]);
  if (loading) {
    return <Loading count={1} col={12} />;
  }

  return (
    <div className="content mb-4">
      <div
        className="content my-3 content-blog"
        style={{
          textAlign: "justify",
        }}
        dangerouslySetInnerHTML={{
          __html: data.data.content,
        }}
      ></div>
    </div>
  );
};

export default BlogContent;
